<template>
  <div class="app" id="registerSafePlaceUser-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-3 mb-4">
          <Header></Header>
        </b-col>
        <b-col class="mt-5 mb-5" xl="8" lg="12">
          <b-form>
            <div class="card" style="border-radius: 11px;">
              <div class="card-header">
                <p style="font-weight: bold">
                  PASSPORT
                </p>
              </div>
              <div class="card-body">
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert = false"
                  >{{ mData.dataDefault.error }}</b-alert
                >
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="
                    mData.dataDefault.showDismissibleAlertSuccess = false
                  "
                  >{{ mData.dataDefault.success }}</b-alert
                >
                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                  class="mt-1"
                >
                  <el-form-item label prop="anhPassport" class="mb-3 text-center">
                    <el-upload
                      action
                      :auto-upload="false"
                      drag
                      :limit="mData.fileUploadOption.AnhPassport.limit"
                      :accept="mData.fileUploadOption.AnhPassport.accept"
                      :on-change="fn_uploadChangeAnhPassport"
                      :on-preview="fn_uploadPreviewAnhPassport"
                      :on-remove="fn_uploadRemoveAnhPassport"
                      :on-exceed="fn_uploadExceedAnhPassport"
                      :file-list="mData.fileUploadOption.AnhPassport.fileList"
                      :multiple="false"
                      :class="{ hide: mData.dataForm.anhPassport }"
                    >
                      <div v-if="!mData.dataForm.anhPassport">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Drop passport photo here or <em>click to upload</em>
                        </div>
                      </div>
                    </el-upload>
                    <div
                      class="d-flex flex-column justify-content-center"
                      v-if="mData.dataForm.anhPassport"
                    >
                      <b-link v-if="mData.dataDefault.canNext" @click="fn_uploadRemoveAnhPassport()" class="text-center">Upload another passport</b-link>
                      <el-image
                        :src="mData.dataForm.anhPassport"
                        lazy
                      ></el-image>
                    </div>
                  </el-form-item>

                  <el-form-item >
                    <div class="btn-group">
                      <el-button 
                        class="btn-back"
                        @click="fn_go()" 
                        type="info" 
                        plain
                      >BACK</el-button>
                      <el-button
                        class="btn-next"
                        type="primary"
                        @click="fn_submitForm()"
                        v-ladda
                        native-type="submit"
                        :disabled="!mData.dataDefault.canNext"
                        >{{mData.dataDefault.uploading && !mData.dataDefault.canNext ? "Processing..." : "Next" }}</el-button
                      >
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div class="card-footer">
              </div>
            </div>
          </b-form>
        </b-col>
        <b-col md="12" class="text-center mt-3">
          <Footer></Footer>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import AuthService from "../../service/AuthService";
import ForeignApi from "../../moduleApi/ForeignerApi";
import LanguageService from "../../service/LanguageService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import moment from "moment";
import Header from "../../containers/HeaderRegister";
import Footer from "../../containers/FooterRegister";
// import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, { siteKey: '6LfOhN4UAAAAAE-A6tdTZk3q8w2mmYXPm5Ga2E19' });

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      widthA: "",
      heightA: "",
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          dataInfo: null,
          uploading: false,
          canNext: false
        },
        dataForm: {
          anhPassport: null,
        },
        validForm: {
          anhPassport: [
            {
              required: true,
              message: "Please upload your passport photo",
              trigger: "blur",
            },
          ],
        },
        fileUploadOption: {
          AnhPassport: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          sessionStorage.setItem(
            "foreignRegister",
            JSON.stringify({ ho_chieu: this.mData.dataDefault.dataInfo })
          );
          this.$router.push("/auth/travelpass-register/passport-information");
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    async fn_initData() {
      let data = sessionStorage.getItem("foreignRegister")
        ? JSON.parse(sessionStorage.getItem("foreignRegister"))
        : {};
        console.log("data",data);
      if (data && data.ho_chieu && data.ho_chieu.anh_id) {
        this.mData.dataDefault.dataInfo = data.ho_chieu;
        this.mData.dataForm.anhPassport =
          window.MyConfig.hostApi + "file/thumb?r=x&w=1024&id=" + data.ho_chieu.anh_id;
        this.mData.dataDefault.canNext = true;
      }else if(data && data.dataPassport && data.dataPassport.ho_chieu && data.dataPassport.ho_chieu.anh_id){
        this.mData.dataDefault.dataInfo = data.dataPassport.ho_chieu;
        this.mData.dataForm.anhPassport =
          window.MyConfig.hostApi + "file/thumb?r=x&w=1024&id=" + data.dataPassport.ho_chieu.anh_id;
        this.mData.dataDefault.canNext = true;
      }
    },
    async checkIdCard(id) {
      let dataIdCard = {};
      try {
        let response = await ForeignApi.ocr(id);
        let res = response.result ? JSON.parse(response.result) : {};
        if (res.result_code == 200 && res.document == "PASSPORT") {
          dataIdCard = res;
        }
      } catch (err) {
        console.log("err xác thực cmnd", err);
      }
      return dataIdCard;
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhPassport() {
      this.mData.dataForm.anhPassport = null;
      this.mData.fileUploadOption.AnhPassport.fileList = [];
      this.mData.dataDefault.canNext = false;
    },
    async fn_uploadChangeAnhPassport(file, fileList) {
      this.mData.dataDefault.uploading = true;
      ExtensionService.upload(file, "foreigner")
        .then(async (res) => {
          this.mData.dataForm.anhPassport = window.MyConfig.hostApi + "file/thumb?r=x&w=1024&id=" + res.result;
          let dataCard = await this.checkIdCard(res.result);
          if (Object.keys(dataCard).length == 0) {
            window.toastr.error("Please upload your passport photo");
            $.each(fileList, (i, el) => {
              if (el.uid == file.uid) {
                fileList.splice(i, 1);
              }
            });
            this.mData.dataForm.anhPassport = null;
            this.mData.dataDefault.uploading = false;
            return;
          }
          this.mData.dataDefault.dataInfo = this.fn_convertPassportData(
            dataCard
          );
          this.mData.dataDefault.dataInfo["anh_id"] = res.result;
          this.mData.dataForm.anhPassport =
            window.MyConfig.hostApi + "file/thumb?r=x&w=1024&id=" + res.result;
          this.mData.dataDefault.uploading = false;
          this.mData.dataDefault.canNext = true;
          console.log("this.mData.dataDefault.dataInfo",this.mData.dataDefault.dataInfo);
        })
        .catch((error) => {
          toastr.error("An error occurred!");
          this.mData.dataDefault.uploading = false;
          this.mData.dataDefault.canNext = false;
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhPassport(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhPassport.limit} file`
      );
    },
    fn_uploadPreviewAnhPassport(file) {
      this.mData.fileUploadOption.AnhPassport.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhPassport.dialogVisible = true;
    },

    fn_convertPassportData(data) {
      let gender = {
        Nam: 1,
        Nữ: 2,
        Khác: 4,
      };
      let ho_chieu = {};
      ho_chieu["loai"] = data.id_type != "N/A" ? data.id_type : "";
      ho_chieu["ma_so"] = data.country != "N/A" ? data.country : "";
      ho_chieu["so_ho_chieu"] = data.id != "N/A" ? data.id : "";
      ho_chieu["ho_ten"] = data.name != "N/A" ? data.name : "";
      ho_chieu["quoc_tich"] = data.national != "N/A" ? data.national : "";
      ho_chieu["ngay_sinh"] = this.checkValidate(data.birthday);
      ho_chieu["noi_sinh"] = data.address != "N/A" ? data.address : "";
      ho_chieu["gioi_tinh"] = data.sex != "N/A" ? gender[data.sex] : null;
      ho_chieu["cmnd"] = null;
      // ho_chieu["ngay_cap"] = this.checkValidate(data.issue_date);
      ho_chieu["hieu_luc_den"] = this.checkValidate(data.expiry);
      ho_chieu["noi_cap"] = data.issue_by != "N/A" ? data.issue_by : "";
      return ho_chieu;
    },
    checkValidate(date) {
      let newDate;
      if (date) {
        date = date.split('-');
        newDate = date[1] + '-' + date[0] + '-' + date[2];
        if (isNaN(new Date(newDate).getTime())) {
          newDate = null;
        }else {
          newDate = date[2] + '-' + date[1] + '-' + date[0] + "T00:00:00+07:00";
        }
      }
      console.log(newDate, 'date');
      return newDate
    },
    fn_go() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.fn_initData();
    this.widthA =  screen.width;
    this.heightA = screen.height;
  },
  created() {},
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
#registerSafePlaceUser-page {
  background-color: #e8eef2;
  background-attachment: fixed;
  background-position: top center;
}
.card{
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px;
}
.card-header{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 55px;
  background-color: #0c66ad;
  border-color: #0c66ad;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-header p{
  margin-bottom: 0 !important;
  color: #ffffff;
  font-size: 20px;
}
.card-body{
  padding: 20px 20px 0 20px;
}
.card-footer{
  background-color: #0c66ad;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 10px;
  padding: 0;
}
.btn-group{
  padding: 0 50px 0 50px;
  display: flex;
  justify-content: space-between;
}
.btn-group .btn-back{
  background-color: #ade0eb;
  border-color: #ade0eb;
  color: #0c66ad;
  font-weight: 700;
}
.btn-group .btn-back:hover{
  border-color: #ade0eb;
}
.btn-group .btn-next{
  background-color: #0c66ad;
  border-color: #0c66ad;
}
.btn-group .btn-next:hover{
  border-color: #0c66ad;
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}
::v-deep .el-button.is-disabled:hover{
  cursor: not-allowed;
}
::v-deep .el-upload {
  display: block;
  margin-bottom: 15px;
}
::v-deep .el-upload-dragger {
  width: 100%;
}
::v-deep img {
  object-fit: cover;
  object-position: center;
}

@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h4 {
    font-size: 16px;
  }
  h5 {
    font-size: 14px;
  }
  .text {
    font-size: 12px;
  }
}
@media screen and (max-width: 1199px) {
  .card-image {
    display: none;
  }
  .card-content {
    padding: 50px;
  }

  .container {
    max-width: 540px;
  }

  .content-header{
    margin-bottom: 20px;
  }

  .logo{
    max-width: 125px;
  }
}
</style>